import React from "react";
import { BannerInterface } from "src/store/mine_craft/bannersSlice";
import { UserInterface } from "src/store/mine_craft/usersSlice";
import CardImage from "../../../../componets/CardImage";
import { formattedDate } from "../../../../helpers/DateHelpers";
import { ButtonDestroy, ButtonEdit } from "../../../../componets/Buttons";
import { EntityId } from "@reduxjs/toolkit";
import { setEditId } from "../../../../store/mine_craft/bannersSlice";
import { useAppDispatch } from "../../../../store/hooks";
import { destroyBanner } from "../../../../actions/mine_craft/bannersActions";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import Meta from "../../../mine_craft/Users/_partials/_Meta";
import usePermissions from "../../../../hooks/usePermissions";

interface propsInterface {
  banner: BannerInterface;
  user?: UserInterface | undefined;
}

const Card = ({ banner, user }: propsInterface) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const formattedCreatedAt = formattedDate(banner.created_at);
  const { write_minecraft } = usePermissions();

  function onClickEdit(id: EntityId)  {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyBanner(id));

    if (destroyBanner.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(0), 1000);
    }

    if (destroyBanner.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  return (
    <CardImage
      className={'v-mine_craft-banners__card'}
      image={banner.image_url}
      size='medium'
      options={write_minecraft ? [
        <ButtonEdit key={`edit-${banner.id}`} onClick={() => onClickEdit(banner.id)} />,
        <ButtonDestroy key={`destroy-${banner.id}`} onClick={() => onClickDestroy(banner.id)} />
      ] : []}
    >
      {user && <Meta user={user} size='xsmall' />}

      <div className='v-small_text'>
        {formattedCreatedAt && <small>{formattedCreatedAt.date} <small>{formattedCreatedAt.time}</small></small> }
      </div>
    </CardImage>
  )
}

export default Card;
